:host {
  .loader-container {
    height: 254px;
    border-radius: 10px;
  }
  .node-scroll {
    background-color: transparent;
    padding: 1px;
    &.end-scroll {
      padding: 0;
    }
  }

  .recent-news {
    .skeleton {
      padding: 24px 16px 16px;
      width: 100%;
      box-sizing: border-box;
      display: block;
      border-bottom: 1px solid var(--divider);
      & *:not(&--title) {
        @include skeletonRipple;
      }

      &--info {
        width: 60px;
        height: 16px;
        margin-bottom: 16px;
      }
      &--title {
        width: 150px;
        height: 24px;
        margin-bottom: 16px;
        display: flex;
        align-items: baseline;
        gap: 8px;

        &--avatar {
          height: 24px;
          min-width: 24px;
          @include skeletonRipple;
        }

        &--title {
          width: 100%;
          height: 20px;
          @include skeletonRipple;
        }
      }
      &--content {
        width: 100%;
        height: 90px;
      }
      &--link {
        width: 170px;
        height: 18px;
        margin-top: 8px;
      }
      &--image {
        width: 100%;
        height: 365px;
        margin-top: 16px;
      }
      &--date {
        margin-top: 16px;
        width: 80px;
        height: 14px;
        margin-left: auto;
      }
    }

    &__header {
      position: -webkit-sticky;
      background: var(--floating-panel-background, var(--bg-primary, #fff));
      position: sticky;
      top: 0;
      padding: 24px 16px 16px;
      border-bottom: 1px solid var(--divider);
      display: flex;
      align-items: center;
      justify-content: space-between;

      .container {
        display: flex;
        gap: 8px;
        align-items: center;
        width: 100%;
        &__title {
          font-size: 14px;
          font-weight: 500;
          color: var(--font-primary);
          margin-right: auto;
          cursor: pointer;
          span {
            padding: 5px 9px;
            background: var(--bg-blue-manager);
            color: var(--blue);
            border-radius: 38px;
            margin-left: 8px;
            font-size: 12px;
          }
        }

        &__action {
          color: var(--button-font-disabled, #9f9f9f);
          cursor: pointer;
          display: block;
          &.active {
            color: var(--blue-hover);
          }
        }
      }

      .all-read-link {
        font-size: 14px;
        font-weight: 400;
        color: var(--blue-link);
        cursor: pointer;
      }
    }
    .no-item {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      margin-top: 24px;
      padding-bottom: 24px;
      img {
        margin-bottom: 16px;
      }
      div {
        margin-right: 16px;
        margin-left: 16px;
        text-align: center;
        font-size: 14px;
        font-weight: 400;
        color: var(--font-primary);
      }

      span {
        margin-top: 4px;
        cursor: pointer;
        margin-right: 16px;
        margin-left: 16px;
        text-align: center;
        font-size: 14px;
        font-weight: 400;
        color: var(--blue);
      }
    }
  }
}
